import { useMemo, useState } from 'react';

import {
  EDoctorFilterType,
  MAX_FILTER_SELECTION,
  getHighReviewCountFromFilters,
  getHighReviewRatingFromFilters,
  getSpecialistOnlyFromFilters,
} from '@/models/diagnosis/doctor-filter';
import { useToast } from 'doctornow-design-system';

export const useDoctorFilterToggle = () => {
  const { toast } = useToast();
  const [selectedFilters, setSelectedFilters] = useState<EDoctorFilterType[]>([]);

  const specialistOnly = useMemo(() => getSpecialistOnlyFromFilters(selectedFilters), [selectedFilters]);

  const highReviewRating = useMemo(() => getHighReviewRatingFromFilters(selectedFilters), [selectedFilters]);

  const highReviewCount = useMemo(() => getHighReviewCountFromFilters(selectedFilters), [selectedFilters]);

  const handleToggleFilter = (filterType: EDoctorFilterType) => {
    setSelectedFilters((prev) => {
      if (prev.includes(filterType)) {
        return prev.filter((f) => f !== filterType);
      }

      if (prev.length >= MAX_FILTER_SELECTION) {
        toast({
          text: `최대 ${MAX_FILTER_SELECTION}개까지 선택할 수 있어요`,
          direction: 'bottom',
        });
        return prev;
      }

      return [...prev, filterType];
    });
  };

  return {
    selectedFilters,
    specialistOnly,
    highReviewRating,
    highReviewCount,
    handleToggleFilter,
  };
};
